<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import { get } from "svelte/store";
    import {currentTable} from "../stores/tablesStore";
    import PokerCard from './PokerCard.svelte';
    import PokerChips from './PokerChips.svelte';
    import PokerDealer from './PokerDealer.svelte';
    import Layout from '../controllers/Layout';
    import Timer from './Timer.svelte';
    import {cssVariables} from '../utils/CSSVariables';
    import userStore from '../stores/userStore';
    
    export const ACTION_TIME = 30;

    export let seatNo;
    let originalSeatNo;
    let posX;
    let posY;
    let playerX;
    let playerY;
    let xGiftButtonOffset;
    let yGiftButtonOffset;
    let xCoffeeOffset;
    let yCoffeeOffset;
    let backColor = "white";
    let giftButton;
    let userId;
    let username;
    let photo;
    let chips;
    let bet;
    let timer;
    let hiddenSitButton = false;
    let dealerButton;
    let holeCards = [];
    let status = "waiting";
    let isActive = false;
    let sitOut = false;
    let playing = false;
    let winnings = "";
    let bbjp = "";
    let showCoffee = false;
    const dispatcher = createEventDispatcher();

    onMount(async () => 
    {
        originalSeatNo = parseInt(seatNo);

        let tableType = get(currentTable).table_type;
        posX = Layout[tableType]["seat" + originalSeatNo].seat[0];
        posY = Layout[tableType]["seat" + originalSeatNo].seat[1];
        playerX = posX + Layout[tableType]["seat" + originalSeatNo].playerOffset[0];
        playerY = posY + Layout[tableType]["seat" + originalSeatNo].playerOffset[1];

        xGiftButtonOffset = -15;
        yGiftButtonOffset = -15;
        xCoffeeOffset = Layout[tableType]["seat" + originalSeatNo].coffeeOffset[0];
        yCoffeeOffset = Layout[tableType]["seat" + originalSeatNo].coffeeOffset[1];
	});

    export function showSitButton(value) 
    { 
        console.log("showSitButton");
        hiddenSitButton = !value;
    }

    export function setPlayerData(data) 
    { 
        console.log("setPlayerData: " + JSON.stringify(data));
        if (data)
        {
            userId = data.userId;
            username = data.username;
            photo = data.photo;
            chips = data.chips;
            setStatus("waiting");
        }
        else
        {
            userId = null;
            showCoffee = false;
        }
    }

    export function setActive(value, onTimeout = null, timeLeft = 0)
    {
        isActive = value;
        if (isActive)
        {
            backColor = "darkgoldenrod";
            timer.setCountDown(ACTION_TIME, onTimeout, timeLeft);
        }
        else
        {
            if (sitOut)
                backColor = "gray";
            else
                backColor = "white";
            if (timer)
                timer.clearCountDown();
        }
    }

    export function setSitOut(value)
    {
        sitOut = value;
        if (sitOut)
            backColor = "gray";
        else
            backColor = "white";
    }

    export function isSitOut()
    {
        return sitOut;
    }

    export function setCards(firstCard, secondCard, scheduledReveal = false) 
    { 
        if (holeCards && holeCards[0] && holeCards[1])
        {
            holeCards[0].setCardValue(firstCard);
            holeCards[1].setCardValue(secondCard);
            holeCards[0].setHidden("false");
            holeCards[1].setHidden("false");

            if (getStatus() == "fold")
                foldCards();

            if (scheduledReveal)
            {
                holeCards[0].scheduledReveal();
                holeCards[1].scheduledReveal();
            }
        }
    }

    export function clearCards() 
    { 
        if (holeCards && holeCards[0] && holeCards[1])
        {
            holeCards[0].setCardValue(null);
            holeCards[1].setCardValue(null);
            holeCards[0].setHidden("true");
            holeCards[1].setHidden("true");
        }
    }

    export function foldCards() 
    { 
        if (holeCards && holeCards[0] && holeCards[1])
        {
            holeCards[0].setFolded(true);
            holeCards[1].setFolded(true);
        }
    }

    export function getCards() 
    { 
       return holeCards;
    }

    export function hasCards()
    {
        return holeCards && holeCards[0] && holeCards[1] && holeCards[0].getCardValue() && holeCards[1].getCardValue();
    }

    export function setBet(amount)
    {
        if (bet)
            bet.setAmount(amount);
    }

    export function getBet()
    {
        return bet ? bet.getAmount() : 0;
    }

    export function setChips(value)
    {
        chips = value;
    }

    export function winChips(amount)
    {
        winnings = "+" + amount;
        setTimeout(() => { winnings = ""; }, 3000);
        setChips(getChips() + amount);
    }

    export function awardBBJP(amount)
    {
        bbjp = "+" + amount;
        setTimeout(() => { bbjp = ""; }, 5000);
    }

    export function getChips()
    {
        return chips;
    }

    export function setDealer(value)
    {
        if (dealerButton)
            dealerButton.setHidden(!value);
    }

    export function setStatus(value)
    {
        status = value;
    }

    export function getStatus()
    {
        return status;
    }

    export function setPlaying(value)
    {
        playing = value;
    }

    export function isPlaying()
    {
        return playing;
    }

    export function setCountDown(value)
    {
        timer.setCountDown(value);
    }

    export function clearCountDown()
    {
        timer.clearCountDown();
    }

    export function getSeatNo()
    {
        return parseInt(seatNo);
    }

    export function getOriginalSeatNo()
    {
        return parseInt(originalSeatNo);
    }

    export function setSeatNo(value, maxSeats)
    {
        if (value < 1)
            value = maxSeats + value;
        if (value > maxSeats)
            value = value - maxSeats;
        
        seatNo = value;
    }

    export function getUserId()
    {
        return userId;
    }

    export function getUserName()
    {
        return username;
    }

    export function getPhoto()
    {
        return photo;
    }

    export function showGift(gift)
    {
        if (gift == "coffee")
            showCoffee = true;
    }

    //------------------------------------------------------------------------------------------------------
    
    function sitDown()
    {
        dispatcher('sitDown', {seatNo: parseInt(originalSeatNo)});
    }

    function onReveal(event)
    {
        dispatcher('reveal', {cardIndex: event.detail.cardIndex, revealed: event.detail.revealed, userId: userId});  //add userId, repackage and forward event
    }

    function onMouseOver()
    {
        giftButton.style.display = "block";
    }

    function onMouseOut()
    {
        giftButton.style.display = "none";
    }

    function onSendGift()
    {
        dispatcher('sendGift', {seatNo: parseInt(originalSeatNo)});
    }

    function openProfilePanel()
    {
        dispatcher('openProfilePanel', {user_id: userId, name: username, avatar: photo});
    }
  

</script>

<!-- <svelte:options accessors={true}/> -->

{#if userId}
<div>
    <div class="vbox center pokerPlayer" on:mouseenter={onMouseOver} on:mouseleave={onMouseOut} use:cssVariables={{playerX, playerY, backColor, xGiftButtonOffset, yGiftButtonOffset, xCoffeeOffset, yCoffeeOffset}}>
        <div style="width: 70px;">
            <span class="winnings">{winnings}</span>
            <span class="bbjp">{bbjp}</span>
            {username}
            <div on:click={openProfilePanel}><img class="profilePhoto" src={photo} alt="User Profile"></div>
            <span style="width:70px">{chips}</span>
            <div class="status">{status}</div>
            <PokerDealer bind:this={dealerButton} seat={originalSeatNo}/>
            <PokerChips bind:this={bet} seat={originalSeatNo} amount=0/>
            <PokerCard bind:this={holeCards[0]} seat={originalSeatNo} cardNo=0 on:reveal={onReveal}/>
            <PokerCard bind:this={holeCards[1]} seat={originalSeatNo} cardNo=1 on:reveal={onReveal}/>
            <Timer bind:this={timer}/>
        </div>
        <img bind:this={giftButton} class="giftButton" on:click={onSendGift}  use:cssVariables={xGiftButtonOffset, yGiftButtonOffset} src={"/assets/gift.png"} alt="Send Gift">
        {#if showCoffee}
        <img class="coffeeGift"  use:cssVariables={xCoffeeOffset, yCoffeeOffset} src={"/assets/coffee.png"} alt="Coffee">
        {/if}
    </div>
    
    
</div>
{:else}
    {#if !hiddenSitButton}
        <ion-button class="sitButton" use:cssVariables={{posX, posY}} on:click={()=>sitDown()}>Sit</ion-button>
    {/if}
{/if}

<style>
    .status {
        background-color: brown;
        font-size: small;
        font-weight: bolder;
        font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
    }

    .winnings {
        position: absolute;
        color: yellow;
        top: -20px;
        left: 20px;
        z-index: 100;
    }

    .bbjp {
        position: absolute;
        color: red;
        top: -20px;
        left: 20px;
        z-index: 100;
    }

    .pokerPlayer {
        position: absolute; 
        font-size: small;
        text-align: center; 
        background-color: var(--backColor);
        left: calc(var(--playerX) * 1px);
        top: calc(var(--playerY) * 1px);
        padding: 0px;
        border-style: solid;
        border-color: white;
        border-width: 1px;
        cursor: default;
    }

    .sitButton {
        position: absolute; 
        left: calc(var(--posX) * 1px);
        top: calc(var(--posY) * 1px);
    }

    .profilePhoto {
        width: 40px;
        height: 40px;
    }

    .giftButton {
        display: none;
        width: 20px;
        height: 20px;
        position: absolute; 
        margin: 0px;
        padding: 0px;
        left:  calc(var(--xGiftButtonOffset) * 1px);
        top:  calc(var(--yGiftButtonOffset) * 1px);
    }
    .giftButton:hover { 
        transform: scale(1.2); 
        cursor: pointer;
    }
    .coffeeGift {
        width: 30px;
        height: 23px;
        position: absolute; 
        margin: 0px;
        padding: 0px;
        left:  calc(var(--xCoffeeOffset) * 1px);
        top:  calc(var(--yCoffeeOffset) * 1px);
    }
</style>